/* eslint-disable no-param-reassign */
/* eslint-disable import/prefer-default-export */
export function checkOverflow(el) {
  const curOverflow = el.style.overflow;

  if (!curOverflow || curOverflow === 'visible') el.style.overflow = 'hidden';

  const isOverflowing = el.clientWidth < el.scrollWidth || el.clientHeight < el.scrollHeight;

  el.style.overflow = curOverflow;

  return isOverflowing;
}

export function getSiblings(e) {
  // for collecting siblings
  const siblings = [];
  // if no parent, return no sibling
  if (!e.parentNode) {
    return siblings;
  }
  // first child of the parent node
  let sibling = e.parentNode.firstChild;

  // collecting siblings
  while (sibling) {
    if (sibling.nodeType === 1 && sibling !== e) {
      siblings.push(sibling);
    }
    sibling = sibling.nextSibling;
  }
  return siblings;
}

export function closeSiblingsDropdown(siblings) {
  siblings.forEach((el) => {
    const select = el.querySelector('.button-select');
    const fieldsetCheckboxes = el.querySelector('fieldset');

    const sectorSpec = el.querySelector('#sector-specialisation-wrapper');

    if (select && fieldsetCheckboxes) {
      select.classList.remove('active');
      fieldsetCheckboxes.classList.remove('active');
    }

    if (sectorSpec) {
      sectorSpec.classList.remove('active');
    }
  });
}
